import {Component} from 'react'
import Loader from 'react-loader-spinner'

import CastItem from '../CastItem'

import './index.css'

class SingleMovieDetails extends Component {
  state = {movieObj: {}, loading: true, castList: []}

  componentDidMount() {
    this.getMovieDetails()
  }

  MovieObjCaseConvert = item => ({
    runtime: item.runtime,
    posterPath: item.poster_path,
    originalTitle: item.original_title,
    overview: item.overview,
    voteAverage: item.vote_average,
    releasedDate: item.released_date,
    genre: item.genres,
  })

  CastObjCaseConvert = arr =>
    arr.map(item => ({
      id: item.id,

      orignialName: item.original_name,
      character: item.character,
      profilePath: item.profile_path,
    }))

  getMovieDetails = async () => {
    const {match} = this.props
    const {params} = match
    const {id} = params
    const API_KEY = 'f32b79895b21468afbdd6d5342cbf3da'
    const getMovieApi = `https://api.themoviedb.org/3/movie/${id}?api_key=${API_KEY}&language=en-US`
    const getCastApi = `https://api.themoviedb.org/3/movie/${id}/credits?api_key=${API_KEY}&language=en-US`
    const MovieResponseObj = await fetch(getMovieApi)
    const castResponseObj = await fetch(getCastApi)
    if (MovieResponseObj.ok && castResponseObj.ok) {
      const MoviedataObj = await MovieResponseObj.json()
      const castDataList = await castResponseObj.json()
      console.log(MoviedataObj)
      //   console.log(castDataList);
      const updatedMovieObj = this.MovieObjCaseConvert(MoviedataObj)
      const updatedCastList = this.CastObjCaseConvert(castDataList.cast)
      this.setState(prevState => ({
        movieObj: updatedMovieObj,
        castList: updatedCastList,
        loading: !prevState.loading,
      }))
    }
  }

  render() {
    const {movieObj, castList, loading} = this.state
    console.log(castList)
    const {
      posterPath,
      originalTitle,
      voteAverage,
      overview,
      runtime,
      genre,
    } = movieObj
    const rating = Math.round(voteAverage)
    return (
      <>
        {loading ? (
          <section className="loader-container">
            <Loader type="Oval" color="green" className="loader-style" />
          </section>
        ) : (
          <section className="section-container-movie-details p-4">
            <div className="container-movie-details">
              <div className="movie-details-container">
                <img
                  src={`http://image.tmdb.org/t/p/original/${posterPath}`}
                  alt={originalTitle}
                  className="movie-poster-in-details"
                />

                <div className="text-container">
                  <p className="movie-name">{originalTitle}</p>
                  <p>{overview}</p>
                  <p>rating:{rating}</p>
                  <p>{runtime} min</p>
                  <p>Genres</p>
                  <ul className="genres">
                    {genre.map(item => (
                      <li key={item.id}>{item.name}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="cast-details-container">
                <p className="cast-head">Cast</p>
                <ul className="cast-details">
                  {castList.map(item => (
                    <CastItem key={item.id} details={item} />
                  ))}
                </ul>
              </div>
            </div>
          </section>
        )}
      </>
    )
  }
}

export default SingleMovieDetails
